import { PRESET_ICON_IDS, type PresetIconId } from '@nxorbit/shared-schema';

/**
 * Preset icon library — 30 monochrome line-style SVGs shipped under
 * `/icons/shortcuts/<id>.svg`. Used by:
 *   - the admin Shortcuts tab's icon picker (5×6 grid)
 *   - the embed FAB's category chips (renders `<img>` with currentColor mask)
 *
 * Files use `stroke="currentColor"` so they automatically adapt to
 * surrounding text color in both the dark admin and the light/dark
 * embed.
 */

export interface PresetIconMeta {
  id: PresetIconId;
  /** Human label shown under the picker thumbnail; not displayed in embed. */
  label: string;
  /** Public path served by Vite + admin-ui CloudFront. */
  src: string;
}

const LABELS: Record<PresetIconId, string> = {
  heart: '愛心', star: '星星', gift: '禮物', chat: '對話', question: '問號',
  phone: '電話', map: '地圖', cart: '購物車', search: '搜尋', calendar: '日曆',
  wallet: '錢包', game: '遊戲', book: '書本', music: '音樂', camera: '相機',
  settings: '設定', list: '清單', user: '人物', trophy: '獎盃', target: '靶心',
  mail: '信件', bell: '通知', globe: '地球', pin: '地標', lightbulb: '燈泡',
  shopping: '購物袋', package: '包裹', palette: '調色盤', sparkle: '閃光', fire: '火焰',
};

export const PRESET_ICONS: PresetIconMeta[] = PRESET_ICON_IDS.map((id) => ({
  id,
  label: LABELS[id],
  src: `/icons/shortcuts/${id}.svg`,
}));

export function resolvePresetIcon(id: PresetIconId): PresetIconMeta {
  // The map is total — id is constrained by the enum — so this lookup
  // never returns undefined at runtime; the non-null assertion is
  // mechanical here.
  return PRESET_ICONS.find((p) => p.id === id)!;
}
